import * as React from "react";
import * as ReactDOM from "react-dom";
import { Router } from "react-router";
import App from "./App";
import { Routes } from "./constants/Routing";
import "./index.css";
import {Measurement} from "./constants/Measurement";

// This needs to exist outside of React since it only needs to be registered once.
Measurement.init();

ReactDOM.render(
    <Router history={Routes.BROWSER_HISTORY}>
        <App />
    </Router>,
document.getElementById("root") as HTMLElement,
);



// WEBPACK FOOTER //
// ./src/index.tsx